export default "__VITE_ASSET__DFnWM0WA__"